
import colours from './colours';

export default {
  colours: colours,
};
